<template>
    <section class="profile-section">
        <div class="container">
            <!-- Main Profile Content -->
            <div class="profile-main">
                <div class="profile-image">
                    <div class="media-container">
                        <img
                            src="/images/sylvia-braun-profile-main.jpg"
                            alt="Sylvia Braun"
                            class="img-fluid profile-static-image"
                        >
                    </div>
                </div>

                <div class="profile-content">
                    <h1 class="profile-title">Sylvia Braun</h1>
                    <p class="profile-subtitle">Bruchköbel im Blick.</p>

                    <div class="profile-text">
                        <p>
                            In den letzten sechs Jahren ist viel passiert – sichtbar, spürbar, gemeinsam gestaltet. Doch
                            es gibt noch viel zu tun. Auf dieser Seite finden Sie meine Ziele für die kommenden Jahre:
                            klar, machbar und mit Leidenschaft für unsere Stadt entwickelt.
                        </p>

                        <div class="goals-link">
                            <button @click="showGoals" class="goals-detail-link">
                                <span class="arrow">»</span>
                                <span class="link-text"> mehr über meine Ziele</span>
                            </button>
                        </div>
                    </div>

                    <!-- Termine Section -->
                    <div class="termine-section">
                        <h2 class="termine-title">Termine</h2>
                        <p class="termine-subtitle">Ganz persönlich</p>
                        <div class="termine-text">
                            <p>
                                Ob mit dem Rad durch unsere schöne Gemarkung oder zu Fuß durch die Innenstadt oder 
                                klassisch am Infostand – es gibt neben meiner Ansprechbarkeit als Ihre Bürgermeisterin 
                                zahlreiche Gelegenheiten mit mir als Kandidatin ins Gespräch zu kommen.
                            </p>
                            <div class="termine-link">
                                <button @click="showTermine" class="termine-detail-link">
                                    <span class="arrow">»</span>
                                    <span class="link-text"> mehr über die termine</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Experience Section - Desktop: Below main text -->
                    <div class="experience-section">
                        <div class="experience-content">
                            <h2 class="experience-title">Führung braucht Erfahrung</h2>
                            <div class="experience-text">
                                <p>
                                    Als erfahrene Polizistin mit über 30 Jahren im Dienst, davon viele Jahre in
                                    leitender Funktion und digitaler Forensik, bringe ich Durchsetzungsvermögen,
                                    Verantwortungsbewusstsein und modernes Denken mit. Privat tief in Roßdorf
                                    verwurzelt, weiß ich, was die Menschen bewegt. Mein politisches Engagement wuchs aus
                                    echtem Bedarf vor Ort – vom Elternbeirat bis ins Rathaus. Seit 2020 bin ich Ihre
                                    Bürgermeisterin von Bruchköbel. Ich kandidiere erneut, weil ich überzeugt bin:
                                    Führung, Nähe und Sachverstand gehören zusammen – und genau das bringe ich mit.
                                </p>
                                <div class="highlight-text">
                                    <button @click="showProfile" class="profile-link">
                                        <span class="arrow">»</span>
                                        <span class="link-text"> mehr über mich erfahren</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ProfileSection',
    methods: {
        showProfile() {
            this.$emit('show-profile')
        },
        showGoals() {
            this.$emit('show-goals')
        },
        showTermine() {
            this.$emit('show-termine')
        }
    }
}
</script>